import { useEffect, useState } from "react";
import ContentBlockComponent from "../../components/content_block";
import APIclient from "../../api-client";
import { translate } from "../../translations";
import { ContentBlock, StaticPage, Stored } from "../../types";

export default function Privacy() {
  const [blocks, setBlocks] = useState<Array<Stored<ContentBlock>>>([]);

  useEffect(() => {
    APIclient.contentBlocks.index(StaticPage.Privacy).then(setBlocks);
  }, []);

  return (
    <>
      <h1 className="page__title">
        <span className="--highlighted">
          {translate("general_privacy_title")}
        </span>
      </h1>
      <section className="static-content">
        {blocks.map((block) => (
          <ContentBlockComponent block={block} key={block._id} />
        ))}
      </section>
    </>
  );
}
